import React from 'react';
import cx from 'classnames';
import Tooltip from 'components/Tooltip';
import StringWidget from 'components/StringWidget';
import { InfoIcon } from 'components/Icons/Icons';
import PriceDescription from 'widgets/ProductPageSummary/PriceTooltip/PriceDescription';
import PopUpPriceInfo from 'components/CartItem/PopUpPriceInfo';
import PriceRow from 'components/OfferPriceRow/OfferPriceRow';
import { PartPriceKnowMore } from 'components/PartPriceWidget';
import { get } from 'lodash';
import styles from './CartOffer.css';
export function CartOfferTooltip(props) {
    const { appliedOffers, availableOffers, popUpDetails, priceDescriptions, isV4Context, handleCallBack } = props;
    const prebookPriceItems = get(popUpDetails, ['priceDetails', 'prebookPriceItems'], []);
    const savingsSummary = get(popUpDetails, 'savingsSummary');
    const knowMore = get(popUpDetails, 'knowMore');
    const preBookPriceItemChildren = prebookPriceItems &&
        prebookPriceItems.map((lineItem, index) => (<PriceRow text={lineItem.label} value={lineItem.value} textClassName={styles['pre-book-label']} key={index}/>));
    return (<div className={styles['offer-tooltip']}>
			<PopUpPriceInfo details={popUpDetails} appliedOffers={appliedOffers}/>

			{(priceDescriptions || availableOffers.length > 0 || prebookPriceItems) && (<div className={styles['price-desc-and-offers']}>
					<PriceDescription priceDescription={priceDescriptions} containerClass={styles['price-description']}/>

					{availableOffers.length > 0 && (<div className={styles['more-offers']}>
							<StringWidget strKey="cartMoreOffers" className={styles['more-offers-heading']}/>
							{availableOffers.map((promotion, idx) => (<div className={styles['more-offers-text']} data-aid="more-offers" key={idx}>
									{promotion.promotionMessage}
								</div>))}
						</div>)}

					{prebookPriceItems && <div className={styles['prebook-price-items']}>{preBookPriceItemChildren}</div>}
				</div>)}

			{savingsSummary && (<div className={styles['savings-summary']}>
					{savingsSummary}
					<PartPriceKnowMore isV4Context={isV4Context} handleCallBack={handleCallBack} data={knowMore} className={styles['know-more']} onKnowMoreAction={props.handleTooltipAction}/>
				</div>)}
		</div>);
}
export default class CartOffer extends React.Component {
    constructor() {
        super(...arguments);
        this.tooltip = null;
        this.setRef = tooltip => {
            this.tooltip = tooltip;
        };
        this.handleTooltipAction = () => {
            this.tooltip && this.tooltip.hide();
        };
    }
    render() {
        const { cartItem, showOnlyInfoIcon, handleCallBack } = this.props;
        let { otherPromotions, conditionalPromotion } = cartItem;
        const { pricingInfo, prexoOffers, listingId, popUpDetails } = cartItem;
        const priceDescriptions = get(cartItem, 'popUpDetails.priceDescriptions');
        const offerSummary = get(cartItem, 'offerSummary');
        otherPromotions = otherPromotions || [];
        conditionalPromotion = conditionalPromotion || [];
        const appliedOffers = [...otherPromotions];
        prexoOffers && appliedOffers.push(prexoOffers);
        const availableOffers = [...conditionalPromotion];
        let text = null;
        if (offerSummary) {
            const { appliedMessage, availableMessage } = offerSummary;
            text = appliedMessage || availableMessage || null;
        }
        else if (appliedOffers.length) {
            text = (<StringWidget strKey="cartOffersApplied" attributes={{ number: appliedOffers.length, s: appliedOffers.length > 1 ? 's' : '' }}/>);
        }
        else if (availableOffers.length) {
            text = (<StringWidget strKey="cartOffersAvailable" attributes={{ number: availableOffers.length, s: availableOffers.length > 1 ? 's' : '' }}/>);
        }
        if (appliedOffers.length || availableOffers.length || showOnlyInfoIcon) {
            return (<div className={cx({ [styles['info-icon-collapsed']]: showOnlyInfoIcon }, styles['offer-tooltip-text'])}>
					<div className={styles['tooltip-content']} id={`offers-${listingId}`}>
						{text}
						<InfoIcon className={styles['info-icon']} fill="#388e3c"/>
						<Tooltip ref={this.setRef} anchor={`#offers-${listingId}`} theme="light" className={cx(styles['offer-tooltip-container'], { [styles['tooltip-on-info-icon']]: showOnlyInfoIcon })} position="bottom">
							<CartOfferTooltip handleCallBack={handleCallBack} {...{ pricingInfo, priceDescriptions, appliedOffers, availableOffers, popUpDetails }} handleTooltipAction={this.handleTooltipAction}/>
						</Tooltip>
					</div>
				</div>);
        }
        return null;
    }
}
